import { actionCreatorFactory } from 'typescript-fsa';

const actionCreator = actionCreatorFactory('@@xver/maintenance');

export const setMaintenance = actionCreator<boolean>('setMaintenance');
